import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { Subscription } from 'rxjs';
import { Component, OnDestroy } from '@angular/core';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { FilterCondition } from '../../../../filter-administration.model';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

export class VisitorRole {
  id: string;
  nameDictionaryKey: string;
}

@Component({
  selector: 'app-visitor-type-condition-editor',
  templateUrl: './visitor-role-condition-editor.component.html',
  styleUrls: ['./visitor-role-condition-editor.component.scss']
})
export class VisitorRoleConditionEditorComponent implements OnDestroy, FilterDetailsComponent {

  visitorRoles = new Array<VisitorRole>();

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private httpService: HttpService
  ) {

    this.detailsFormGroup.addControl('visitorRole', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      () => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.visitorRole = this.detailsFormGroup.controls.visitorRole.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

    this.httpService.postWithContext<VisitorRole[]>(environment.visitorfilterAdminiEndpoint + '/visitor-roles', {}).subscribe(
      visitorRoles => {
        this.visitorRoles = visitorRoles;
      }
    )
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }

}
